export function getStepsAtStepNumber(
    sequencerEngine,
    stepNumber=sequencerEngine.cursor.step)
{
    let track = sequencerEngine.getSelectedTrack();
    let p = track.getEasyPattern();
    return p.getStepsAtStepNumber(sequencerEngine.cursor.step)
        .map(x => x.step);
}

export function increaseDuration(sequencerEngine) {
    let steps = getStepsAtStepNumber(
        sequencerEngine,
        sequencerEngine.cursor.step)

    for (let i in steps) {
        let duration = steps[i].duration || 1;
        steps[i].duration = duration + 1;
    }

    sequencerEngine.getSelectedTrack().updateSteps();
}

export function decreaseDuration(sequencerEngine) {
    let steps = getStepsAtStepNumber(
        sequencerEngine,
        sequencerEngine.cursor.step);

    for (let i in steps) {
        let duration = steps[i].duration || 1;
        steps[i].duration = Math.max(1, duration - 1);
    }

    sequencerEngine.getSelectedTrack().updateSteps();
}
